let FundamentalTabSortOrderType =  {
  Descending: 0,
  Ascending: 1,
}

export default FundamentalTabSortOrderType;